<template>
    <div v-if="loading"></div>
    <b-tabs v-else>
        <b-tab title="Child Lists">
            <ManagedListsServerTable :collection="childLists" />
        </b-tab>
        <b-tab title="Attributes">
            <div class="mb-5">
                <div class="float-right">
                    <header-button-group :button_config="attribute_button_config" :link_context="list_id" />
                </div>
            </div>
            <ManagedListAttributesServerTable :collection="attributeList" />
        </b-tab>
    </b-tabs>
</template>
<script>
import ManagedListCollection from "@/collections/lab/ManagedListCollection";
import ManagedListsServerTable from "./ManagedListsServerTable.vue";
import ManagedListAttributesServerTable from "./ManagedListAttributesServerTable.vue";
import AttributeListCollection from "@/collections/lab/AttributeListCollection";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import { AccessControlCheck } from "@/auth/AccessControlCheck";

export default {
    name: "ManagedListRelatedTabs",
    components: { 
        ManagedListsServerTable, 
        ManagedListAttributesServerTable, 
        HeaderButtonGroup,
    },
    props: {
        list_id: {
            type: String,
            required: true,
        },
    },
    computed: {
        attribute_button_config() {
            return {
                buttons: [
                {
                    icon: "fa-plus",
                    linkto: "/attributes-lists/add",
                    title: "Add New Attribute",
                    text: "Add Attribute",
                    variant: "success",
                    permission: this.checkPermission("add attribute list"),
                },
                ],
            };
        },
    },
    data() {
        return {
            childLists: null,
            attributesList: null,
            loading: true,
        };
    },
    methods: {
        checkPermission(permission) {
            return AccessControlCheck.checkPermission(permission);
        },
        async init() {
            this.fetch();
        },
        fetch() {
            // set up the managed list and attributes collection objects
            this.fetchManagedList();
            this.fetchAttributesList();
        },
        fetchManagedList() {
            // create an instance of the managed list collection
            const managedList = new ManagedListCollection();
            // get the filter object from the collection
            const Filter = managedList.getFilter();
            // set up the filter
            Filter.filterEquals("parent_id", this.list_id);

            this.childLists = managedList;
        },
        fetchAttributesList() {
            const attributeCollection = new AttributeListCollection();
            const Filter = attributeCollection.getFilter();
            Filter.filterEquals('managed_list_id', this.list_id);

            this.attributeList = attributeCollection;
        }
    },
    watch: {
        list_id: {
            handler() {
                this.loading = true;
                this.init().then(() => {
                    this.loading = false;
                });
            },
            deep: true,
            immediate: true
        }
    },
};
</script>